import Customer         from "../../../domain/customer/Customer";
import CustomerBirthday from "../../../domain/customer/CustomerBirthday";
import CustomerContact  from "../../../domain/customer/CustomerContact";
import CustomerDetail   from "../../../domain/customer/CustomerDetail";
import Address          from "../../../domain/fundamentals/address/Address";
import Name             from "../../../domain/fundamentals/name/Name";
import {
  ACTION_TYPE,
  CustomerAction,
  SetCustomerAction,
  SetCustomerAddressBuildingAction,
  SetCustomerAddressCityAction,
  SetCustomerAddressPostalCodeAction,
  SetCustomerAddressPrefectureAction,
  SetCustomerAddressStreetAction,
  SetCustomerBirthdayDateAction,
  SetCustomerBirthdayMonthAction,
  SetCustomerBirthdayYearAction,
  SetCustomerContactEmailAction,
  SetCustomerContactPhoneAction,
  SetCustomerDetailFirstNameAction,
  SetCustomerDetailFirstNameKanaAction,
  SetCustomerDetailGenderTypeAction,
  SetCustomerDetailLastNameAction,
  SetCustomerDetailLastNameKanaAction,
  SetCustomerDetailNumberAction
}                       from "./CustomerAction";

const reduceCustomer = (action: SetCustomerAction): Customer => action.customer;
const reduceCustomerNumber = (state: Customer, action: SetCustomerDetailNumberAction): Customer => new Customer(
  state.id,
  new CustomerDetail(action.customerNumber, state.detail.name, state.detail.genderType),
  state.birthday,
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerLastName = (state: Customer, action: SetCustomerDetailLastNameAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, new Name(action.lastName, state.detail.name.firstName, state.detail.name.lastNameKana, state.detail.name.firstNameKana), state.detail.genderType),
  state.birthday,
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerFirstName = (state: Customer, action: SetCustomerDetailFirstNameAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, new Name(state.detail.name.lastName, action.firstName, state.detail.name.lastNameKana, state.detail.name.firstNameKana), state.detail.genderType),
  state.birthday,
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerLastNameKana = (state: Customer, action: SetCustomerDetailLastNameKanaAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, new Name(state.detail.name.lastName, state.detail.name.firstName, action.lastNameKana, state.detail.name.firstNameKana), state.detail.genderType),
  state.birthday,
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerFirstNameKana = (state: Customer, action: SetCustomerDetailFirstNameKanaAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, new Name(state.detail.name.lastName, state.detail.name.firstName, state.detail.name.lastNameKana, action.firstNameKana), state.detail.genderType),
  state.birthday,
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerGenderType = (state: Customer, action: SetCustomerDetailGenderTypeAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, state.detail.name, action.genderType),
  state.birthday,
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerBirthYear = (state: Customer, action: SetCustomerBirthdayYearAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, state.detail.name, state.detail.genderType),
  new CustomerBirthday(action.year, state.birthday.month, state.birthday.date),
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerBirthMonth = (state: Customer, action: SetCustomerBirthdayMonthAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, state.detail.name, state.detail.genderType),
  new CustomerBirthday(state.birthday.year, action.month, state.birthday.date),
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerBirthDate = (state: Customer, action: SetCustomerBirthdayDateAction): Customer => new Customer(
  state.id,
  new CustomerDetail(state.detail.number, state.detail.name, state.detail.genderType),
  new CustomerBirthday(state.birthday.year, state.birthday.month, action.date),
  state.contact,
  state.address,
  state.trail,
);
const reduceCustomerPhone = (state: Customer, action: SetCustomerContactPhoneAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(action.phone, state.contact.email),
  state.address,
  state.trail,
);
const reduceCustomerEmail = (state: Customer, action: SetCustomerContactEmailAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(state.contact.phone, action.email),
  state.address,
  state.trail,
);
const reduceCustomerPostalCode = (state: Customer, action: SetCustomerAddressPostalCodeAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(state.contact.phone, state.contact.email),
  new Address(action.postalCode, state.address.prefecture, state.address.city, state.address.street, state.address.building),
  state.trail,
);
const reduceCustomerPrefecture = (state: Customer, action: SetCustomerAddressPrefectureAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(state.contact.phone, state.contact.email),
  new Address(state.address.postalCode, action.prefecture, state.address.city, state.address.street, state.address.building),
  state.trail,
);
const reduceCustomerCity = (state: Customer, action: SetCustomerAddressCityAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(state.contact.phone, state.contact.email),
  new Address(state.address.postalCode, state.address.prefecture, action.city, state.address.street, state.address.building),
  state.trail,
);
const reduceCustomerStreet = (state: Customer, action: SetCustomerAddressStreetAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(state.contact.phone, state.contact.email),
  new Address(state.address.postalCode, state.address.prefecture, state.address.city, action.street, state.address.building),
  state.trail,
);
const reduceCustomerBuilding = (state: Customer, action: SetCustomerAddressBuildingAction): Customer => new Customer(
  state.id,
  state.detail,
  state.birthday,
  new CustomerContact(state.contact.phone, state.contact.email),
  new Address(state.address.postalCode, state.address.prefecture, state.address.city, state.address.street, action.building),
  state.trail,
);

const customerReducer = (state: Customer = new Customer(), action: CustomerAction): Customer => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_CUSTOMER:
      return reduceCustomer(action as SetCustomerAction);
    case ACTION_TYPE.SET_CUSTOMER_DETAIL_NUMBER:
      return reduceCustomerNumber(state, action as SetCustomerDetailNumberAction);
    case ACTION_TYPE.SET_CUSTOMER_DETAIL_LAST_NAME:
      return reduceCustomerLastName(state, action as SetCustomerDetailLastNameAction);
    case ACTION_TYPE.SET_CUSTOMER_DETAIL_FIRST_NAME:
      return reduceCustomerFirstName(state, action as SetCustomerDetailFirstNameAction);
    case ACTION_TYPE.SET_CUSTOMER_DETAIL_LAST_NAME_KANA:
      return reduceCustomerLastNameKana(state, action as SetCustomerDetailLastNameKanaAction);
    case ACTION_TYPE.SET_CUSTOMER_DETAIL_FIRST_NAME_KANA:
      return reduceCustomerFirstNameKana(state, action as SetCustomerDetailFirstNameKanaAction);
    case ACTION_TYPE.SET_CUSTOMER_DETAIL_GENDER_TYPE:
      return reduceCustomerGenderType(state, action as SetCustomerDetailGenderTypeAction);
    case ACTION_TYPE.SET_CUSTOMER_BIRTHDAY_YEAR:
      return reduceCustomerBirthYear(state, action as SetCustomerBirthdayYearAction);
    case ACTION_TYPE.SET_CUSTOMER_BIRTHDAY_MONTH:
      return reduceCustomerBirthMonth(state, action as SetCustomerBirthdayMonthAction);
    case ACTION_TYPE.SET_CUSTOMER_BIRTHDAY_DATE:
      return reduceCustomerBirthDate(state, action as SetCustomerBirthdayDateAction);
    case ACTION_TYPE.SET_CUSTOMER_CONTACT_PHONE:
      return reduceCustomerPhone(state, action as SetCustomerContactPhoneAction);
    case ACTION_TYPE.SET_CUSTOMER_CONTACT_EMAIL:
      return reduceCustomerEmail(state, action as SetCustomerContactEmailAction);
    case ACTION_TYPE.SET_CUSTOMER_ADDRESS_POSTAL_CODE:
      return reduceCustomerPostalCode(state, action as SetCustomerAddressPostalCodeAction);
    case ACTION_TYPE.SET_CUSTOMER_ADDRESS_PREFECTURE:
      return reduceCustomerPrefecture(state, action as SetCustomerAddressPrefectureAction);
    case ACTION_TYPE.SET_CUSTOMER_ADDRESS_CITY:
      return reduceCustomerCity(state, action as SetCustomerAddressCityAction);
    case ACTION_TYPE.SET_CUSTOMER_ADDRESS_STREET:
      return reduceCustomerStreet(state, action as SetCustomerAddressStreetAction);
    case ACTION_TYPE.SET_CUSTOMER_ADDRESS_BUILDING:
      return reduceCustomerBuilding(state, action as SetCustomerAddressBuildingAction);
  }
};

export default customerReducer;
